/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_2_TitleInputs */

const en_mk_studio_2_title = /** @type {(inputs: Mk_Studio_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A PDF proposal in your brand`)
};

const id_mk_studio_2_title = /** @type {(inputs: Mk_Studio_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposal PDF dengan brand-mu`)
};

/**
* | output |
* | --- |
* | "A PDF proposal in your brand" |
*
* @param {Mk_Studio_2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_2_title = /** @type {((inputs?: Mk_Studio_2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_2_title(inputs)
	return en_mk_studio_2_title(inputs)
});